import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import config from '../functions/config';

function RentalHistoryPage() {
  const [rentalHistory, setRentalHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRental, setSelectedRental] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // Fetch rental history on component mount
  useEffect(() => {
    const sessionId = Cookies.get("sessionid");
    console.log("Session ID:", sessionId);

    if (sessionId) {
      fetchRentalHistory(sessionId);
    } else {
      setError("User not authenticated. Please log in.");
      setLoading(false);
    }
  }, []);

  // Fetch rental history from the API
  const fetchRentalHistory = async (sessionId) => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/rentalhistory/`, {
        headers: {
          "X-Session-ID": sessionId,
        },
      });
      if (response.status === 200) {
        setRentalHistory(response.data);
        setLoading(false);
      } else {
        throw new Error("Failed to fetch rental history");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setError("Unauthorized access. Please log in again.");
      } else {
        setError("Error fetching rental history. Please try again later.");
      }
      setLoading(false);
    }
  };

  // Handle "Pay Now" button click
  const handleActionClick = (rental) => {
    setSelectedRental(rental);
    setShowModal(true);
  };

  // Handle payment continuation
  const handleContinuePayment = () => {
    if (selectedRental) {
      navigate(`/pay/${selectedRental.id}`);
    }
    setShowModal(false);
  };

  // Show loading state
  if (loading) return <div>Loading...</div>;

  // Show error state
  if (error) return <div>{error}</div>;

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">Library Management</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
            <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/userhome">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/profile">Profile</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/rentalhistory">Rented Books</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/purchasehistory">Purchase History</a>
              </li>
              <li className="nav-item">
                <a href="/login" className="btn btn-danger">Logout</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Rental History Table */}
      <div className="my-5 container pt-5">
        <h2 className="text-center mb-4">Rental History</h2>
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Book</th>
                <th>Quantity</th>
                <th>Total Price</th>
                <th>Rent Date</th>
                <th>Return Date</th>
                <th>Status</th>
                <th>Fine</th>
                <th>Phone Number</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rentalHistory
                .sort((a, b) => {
                  const statusOrder = { fined: 1, pending: 2, paid: 3 };
                  return statusOrder[a.status.toLowerCase()] - statusOrder[b.status.toLowerCase()];
                })
                .map((rental, index) => (
                  <tr key={index}>
                    <td>{rental.book}</td>
                    <td>{rental.quantity}</td>
                    <td>{rental.total_price} Rs</td>
                    <td>{new Date(rental.rent_date).toLocaleDateString()}</td>
                    <td>{rental.return_date ? new Date(rental.return_date).toLocaleDateString() : "Not Returned"}</td>
                    <td className={rental.status === 'Fined' ? 'text-danger' : ''}>
  {rental.status}
</td>
                    <td>{rental.fine} Rs</td>
                    <td>{rental.phone_number}</td>
                    <td>
                      {rental.status.toLowerCase() !== "paid" && (
                        <button
                          className="btn btn-primary"
                          onClick={() => handleActionClick(rental)}
                        >
                          Pay Now
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Payment Modal */}
      {showModal && selectedRental && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p><strong>Book:</strong> {selectedRental.book}</p>
                <p><strong>Total Price:</strong> {selectedRental.total_price}</p>
                <p><strong>Fine:</strong> {selectedRental.fine || 0}</p>
                <p>
                  <strong>Total Amount to Pay:</strong>{" "}
                  <span className="text-success fw-bold">
                    Rs.{(Number(selectedRental.total_price) + Number(selectedRental.fine || 0)).toFixed(2)}
                  </span>
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleContinuePayment}
                >
                  Continue to Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RentalHistoryPage;
